// @mui
import { Container, Grid } from '@mui/material';

import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';

//Localization
import useLocales from 'src/hooks/useLocales';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from 'src/routes/paths';
import ContractInfoDetailTableRow from './ContractInfoDetailTableRow';
import Loader from 'src/components/loader/Loader';
import { useState, useEffect } from 'react';
// ----------------------------------------------------------------------

export default observer(function ContractInfoDetailHeader() {
  const { translate } = useLocales();
  const {
    ContractInfoStore: {
      selectedContractInfoDetail,
      clearSelectedContractInfo,
      loadContractInfoDetail,
      ID,
      openAttachmentDialog
    },
    RentPaymentStore,
    ElectricityPaymentStore,
    CustomerStore
  } = useStore();

  const { GetRentPaymentHistory, RentPaymentHistoryResult } = RentPaymentStore;
  const { GetElectricityPaymentHistory, ElectricityPaymentHistoryResult } = ElectricityPaymentStore;
  const { loadCustomerDetail, SelectedCustomerDetail } = CustomerStore;
  const [isLoading, setIsLoading] = useState(true); // Loading state

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      loadContractInfoDetail(ID)
        .then(() => {
          loadCustomerDetail(selectedContractInfoDetail?.customerId);
          GetElectricityPaymentHistory({ contractId: ID });
          GetRentPaymentHistory({ contractId: ID });
        })
        .finally(() => setIsLoading(false)); // Ensure loading ends
    }
  }, [ID,loadContractInfoDetail]);

  const { themeStretch } = useSettings();

  // Handle case when no ID or data is available
  if (!ID) {
    return (
      <Page title={translate('contractsInfo.ContractInfoDetails')}>
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <HeaderBreadcrumbs
            heading={translate('contractsInfo.ContractInfoDetails')}
            links={[
              { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
              {
                name: `${translate('contractsInfo.ContractInfo')}`,
                href: PATH_DASHBOARD.ContractInfo.list,
              },
            ]}
          />
          <p>{translate('ContractInfo.NoContractSelected')}</p>
        </Container>
      </Page>
    );
  }

  return (
    <Page title={translate('contractsInfo.contractDetails')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('contractsInfo.contractDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('contractsInfo.Title')}`,
              href: PATH_DASHBOARD.ContractInfo.list,
            },
          ]}
        />
        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <Loader /> {/* Replace with Loader */}
          </Grid>
        ) : selectedContractInfoDetail ? ( // Render details if available
          <Grid container>
            <ContractInfoDetailTableRow
              row={selectedContractInfoDetail}
              clearContractInfo={clearSelectedContractInfo}
              electricityRow={ElectricityPaymentHistoryResult}
              rentRow={RentPaymentHistoryResult}
              openAttachmentDialog={openAttachmentDialog}
            />
          </Grid>
        ) : (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <p>{translate('ContractInfo.NoDetailsFound')}</p>
          </Grid>
        )}
      </Container>
    </Page>
  );
});
